exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TastFooter-module__tast-footer___1_USB{padding:0 18px;display:flex;align-items:center;opacity:.5;cursor:pointer}.TastFooter-module__tast-footer___1_USB p{white-space:nowrap}.TastFooter-module__tast-footer___1_USB img{width:95px;height:auto;margin:0 15px 2px 10px}", ""]);

// exports
exports.locals = {
	"tast-footer": "TastFooter-module__tast-footer___1_USB"
};